import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, GlobalErrorComponent } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import styled from 'styled-components';
import MessageContainer from './MessageContainer';
import {
  modalActions,
  riScenarioActions,
  accountTypesActions,
  salaryActions,
  participantProfileActions,
  incomeEventActions,
} from '../../redux/root-action';
import { modals, responseStatus } from '../../utils/constants';
import { isAEMAuthor, getDomain, isMobileApp } from '../../utils/api';
import LoadingSpinner from '../../LoadingSpinner';
import { keyDown } from '../../utils/helpers';
import RIXIneligible from '../Modals/RIXIneligible';
import { fetchIncomeEvents } from 'redux/income-events/actions';

interface Props {
  title: string;
  linkLabel: string;
  onTrack: string;
  offTrack: string;
  showModal: Function;
  fetchRIScenario: Function;
  fetchPlans: Function;
  fetchRixCompensation: Function;
  fetchSalary: Function;
  fetchAccountTypes: Function;
  fetchIncomeEvents: Function;
  riScenarioFailed?: boolean;
  simulationFailed?: boolean;
  spouseFailed?: boolean;
  salary?: any;
  riScenario?: any;
  salaryAmount?: any;
  isLoading: boolean;
  initialLoad: boolean;
  yodleeRefresh?: any;
  participantProfile?: any;
  rixCompensation?: any;
  plans?: any;
  charts?: any;
}

const HeaderContainer = styled.div`
  width: 100%;
`;

const OuterContainer = styled.div`
  display: flex;
  justify-content: center;
  background: linear-gradient(90deg, #004466 0%, #0d2f40 50%);
  @media only screen and (max-width: 768px) {
    background: #0d2f40;
  }
`;

const Container = styled.div`
  padding: 48px 0px 16px 0px;
  width: 1120px;
  @media only screen and (min-width: 1024px) and (max-width: 1200px) {
    padding: 48px 48px 16px 48px;
    width: 100%;
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    padding: 24px 40px 16px 40px;
    width: 100%;
  }
  @media only screen and (max-width: 767px) {
    padding: 24px 16px 16px 16px;
    width: 100%;
  }
`;

const Title = styled.div`
  font-family: Nimbus Sans Light;
  font-size: 40px;
  line-height: 1.15;
  letter-spacing: -1px;
  color: white;
  padding: 0px 0px 32px 0px;
  @media only screen and (max-width: 768px) {
    font-size: 24px;
  }
`;

const LearnMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  box-shadow: inset 0 -1px 0 0 ${tokens.ColorBrandBrightBlue};
  background-color: #c2edff;
`;

const LearnMoreCopy = styled.div`
  width: 1120px;
  padding: 32px 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;

  @media (max-width: 1024px) {
    width: 100%;
    padding: 24px 48px;
    align-items: baseline;
  }

  @media (max-width: 768px) {
    padding: 24px 16px;
    align-items: baseline;
  }
`;

const LearnMoreIcon = styled.div`
  flex: 0 1 48px;
  img {
    width: 20px;
    height: 20px;
  }
  @media (max-width: 1024px) {
    flex: 1 1 19px;
  }
`;

const LearnMoreText = styled.div`
  flex: 1 auto;
  font-family: Nimbus Sans Bold;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  color: #3b4b59;

  @media (max-width: 1024px) {
    flex: 1 1 93%;
  }

  @media (max-width: 767px) {
    flex: 1 1 85%;
  }
`;

const LearnMoreLink = styled.div`
  flex: 1 auto;
  text-align: right;

  @media (max-width: 1024px) {
    text-align: left;
    padding: 16px 0 0 43px;
  }

  @media (max-width: 768px) {
    padding: 16px 0 0 35px;
  }
`;

class RetirementPlannerContainer extends Component<Props> {
  showInformationAndAssumptionsModal = () => {
    const { showModal } = this.props;
    showModal(modals.INFORMATION_AND_ASSUMPTIONS);
  };

  showLearnMore = () => {
    const { showModal } = this.props;
    showModal(modals.LEARN_MORE_MODAL);
  };

  arrayHasAllSameValues = (arr: any) => arr.every((v: any) => v === arr[0]);

  componentDidMount() {
    const { fetchRIScenario, fetchAccountTypes,fetchIncomeEvents, fetchSalary, fetchPlans, fetchRixCompensation } = this.props;

    fetchRIScenario();
    fetchAccountTypes();
    fetchIncomeEvents();
    fetchSalary();
    // --------
    fetchPlans();
    fetchRixCompensation();
  }

  async componentDidUpdate(prevProps: any) {
    const { salary, riScenario, participantProfile, plans, charts, rixCompensation } = this.props;
    let { simulationFailed } = this.props;
    let isRixEligible = true;
    const w = window as any;

    await w.Services.getRetirementIncomeEligibility().then(function(data: any) {
      if (data.err) {
        return;
      }
      isRixEligible = data.rixeligible;
      if (isRixEligible) {
        w.addScroll();
      }
    });

    // console.log('rixCompensation: ' + rixCompensation);
    //console.log("isRixEligible: " + isRixEligible);
    if (
      typeof rixCompensation !== 'undefined' &&
      typeof rixCompensation.rixUpdateFlag !== 'undefined' &&
      rixCompensation.rixUpdateFlag === true
    ) {
      if (isMobileApp()) {
        window.location.href =
          getDomain() +
          '/workplace/en/participant/no-salary.html?mobile-app=true&returnURL=' +
          getDomain() +
          '/workplace/en/participant/ri/index.html%3Fmobile-app=true';
      } else {
        window.location.href = getDomain() + '/workplace/en/participant/no-salary.html';
      }
    }

    w.multiplanListDisplay();

    simulationFailed = charts.error.status >= 0;
  }

  render(): JSX.Element {
    const {
      title,
      linkLabel,
      onTrack,
      offTrack,
      riScenarioFailed,
      simulationFailed,
      spouseFailed,
      isLoading,
      initialLoad,
      yodleeRefresh,
    } = this.props;
    const w = window as any;
    const setDismissError = document.location.href.indexOf('localhost.troweprice.com') > -1 ? true : false;
    let isRixEligible = true;

    w.Services.getRetirementIncomeEligibility().then(function(data: any) {
      if (data.err) {
        return;
      }
      isRixEligible = data.rixeligible;
      if (isRixEligible) {
        w.addScroll();
      }
    });

    return (
      <HeaderContainer>
        {!isAEMAuthor() && isLoading && <LoadingSpinner isLoading={isLoading} initialLoad={initialLoad} />}
        {!isRixEligible ? (
          <RIXIneligible />
        ) : (
          <>
            {(simulationFailed || riScenarioFailed || yodleeRefresh === responseStatus.ERROR) && (
              <GlobalErrorComponent
                message={`Sorry! We’re having technical problems. Please try again.`}
                refreshText={`Refresh`}
                dismissError={setDismissError}
              />
            )}
            {spouseFailed && (
              <GlobalErrorComponent
                message={`We cannot update your information due to technical issues. Please try again.`}
                refreshText={`Refresh`}
                dismissError={setDismissError}
              />
            )}
          </>
        )}
        <LearnMoreContainer>
          <LearnMoreCopy>
            <LearnMoreIcon>
              <img src={`data:image/svg+xml;base64,${tokens.AssetIconInfoOutline}`} alt="learn more icon" />
            </LearnMoreIcon>
            <LearnMoreText>
              Meet the new Retirement Income Planner. Fine-tune your strategy with our more accurate and enhanced tool.
            </LearnMoreText>
            <LearnMoreLink>
              <Link
                color={tokens.ColorBrandInteractiveBlue}
                linkLabel="Learn How to Get Started"
                customStyles={'font-family: Nimbus Sans Bold; '}
                onClick={isMobileApp() ? this.showLearnMore : null}
                tabIndex={0}
                href={!isMobileApp() && getDomain() + '/content/workplace/en/participant/ri/learn-more.html'}
              />
            </LearnMoreLink>
          </LearnMoreCopy>
        </LearnMoreContainer>
        <OuterContainer>
          <Container>
            <Title tabIndex={0}>{title}</Title>
            <Link
              color="white"
              linkLabel={linkLabel}
              customStyles={'font-style: italic; opacity: 0.7; padding-right: 10px'}
              onClick={this.showInformationAndAssumptionsModal}
              tabIndex={0}
              onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) =>
                keyDown(e, this.showInformationAndAssumptionsModal)
              }
            />
            <Link
              color="white"
              linkLabel="Methodology"
              customStyles={'font-style: italic; opacity: 0.7; padding-left: 10px; border-left: 1px solid #fff'}
              href="/workplace/en/participant/home/methodology-and-assumptions.html"
              tabIndex={0}
            />
          </Container>
        </OuterContainer>
        <MessageContainer onTrackMessage={onTrack} offTrackMessage={offTrack} />
      </HeaderContainer>
    );
  }
}

const mapStateToProps = ({ riScenario, charts, spouse, salary, yodleeConsent, participantProfile }: any) => {
  return {
    riScenarioFailed: riScenario.error.status >= 0,
    simulationFailed: false,
    spouseFailed: spouse.deleteSpouse === responseStatus.ERROR,
    salary,
    riScenario,
    isLoading: riScenario.loading || charts.loading,
    initialLoad: charts.initialLoad,
    yodleeRefresh: yodleeConsent.yodleeRefresh,
    participantProfile: participantProfile.participantProfile,
    plans: participantProfile.plans,
    rixCompensation: participantProfile.rixCompensation,
    charts,
  };
};

export default connect(mapStateToProps, {
  showModal: modalActions.showModal,
  fetchRIScenario: riScenarioActions.fetchRIScenario,
  fetchAccountTypes: accountTypesActions.fetchAccountTypes,
  fetchIncomeEvents: incomeEventActions.fetchIncomeEvents,
  fetchSalary: salaryActions.fetchSalary,
  fetchPlans: participantProfileActions.fetchPlans,
  fetchRixCompensation: participantProfileActions.fetchRixCompensation,
})(RetirementPlannerContainer);
